import { createContext, Dispatch, SetStateAction, useState } from 'react'
import { useWindowEventListener } from './hooks/useWindowEventListener'

export interface AppContextValue {
  filename: string | null
  setFilename: Dispatch<SetStateAction<string | null>>
  audioBuffer: AudioBuffer | null
  setAudioBuffer: Dispatch<SetStateAction<AudioBuffer | null>>
  uploadOpened: boolean
  setUploadOpened: Dispatch<SetStateAction<boolean>>
  dragging: boolean
  setDragging: Dispatch<SetStateAction<boolean>>
  feedbackOpened: boolean
  setFeedbackOpened: Dispatch<SetStateAction<boolean>>
  feedbackLoading: boolean
  setFeedbackLoading: Dispatch<SetStateAction<boolean>>
  hotkeysEnabled: boolean
  setHotkeysEnabled: Dispatch<SetStateAction<boolean>>
}

export const AppContext = createContext({} as AppContextValue)

export function useAppContext(): AppContextValue {
  const [audioBuffer, setAudioBuffer] = useState<AudioBuffer | null>(null)
  const [uploadOpened, setUploadOpened] = useState(false)
  const [dragging, setDragging] = useState(false)
  const [feedbackOpened, setFeedbackOpened] = useState(false)
  const [feedbackLoading, setFeedbackLoading] = useState(false)
  const [hotkeysEnabled, setHotkeysEnabled] = useState(true)
  const [filename, setFilename] = useState<string | null>(null)

  useWindowEventListener('dragenter', () => setDragging(true))

  return {
    filename,
    setFilename,
    audioBuffer,
    setAudioBuffer,
    uploadOpened,
    setUploadOpened,
    dragging,
    setDragging,
    feedbackOpened,
    setFeedbackOpened,
    feedbackLoading,
    setFeedbackLoading,
    hotkeysEnabled,
    setHotkeysEnabled,
  }
}
